<div [class]="'flex items-center justify-center ' + customClasses">
  <ng-template #contentTemplate>
    <ng-container *ngTemplateOutlet="popoverContent"></ng-container>
  </ng-template>
  <span nz-button nz-popover [nzPopoverContent]="contentTemplate" nzPopoverTrigger="hover" class="mb-1">
    <twaice-fe-svg-icon name="info-circle" source="tabler" width="13px" height="13px" />
  </span>
</div>
